import { render, staticRenderFns } from "./ApplicantStudentDetails.vue?vue&type=template&id=9d0c2fde&scoped=true&"
import script from "./ApplicantStudentDetails.vue?vue&type=script&lang=js&"
export * from "./ApplicantStudentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantStudentDetails.vue?vue&type=style&index=0&id=9d0c2fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0c2fde",
  null
  
)

export default component.exports